module.exports = __webpack_public_path__ + "static/media/loader.6f183129.gif";